<template>
    <div class="applicationHeader--background">
        <div class="application--info__wrapper">
            <div class="application--info">
                <h1 class="heading--lg">Apply Anyway</h1>
                <p class="paragraph application__text">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                    nostrud exercitation ullamco laboris nisi.</p>
                <div class="divider"></div>
                <basic-button type="blue">Apply Now</basic-button>
                <basic-button type="transparent"> View Careers</basic-button>
            </div>
        </div>
    </div>
</template>

<script>
    import BasicButton from "../BasicButton";

    export default {
        components: {BasicButton},
        name: "ApplicationHeader"
    }
</script>

<style scoped lang="scss">
    .applicationHeader--background {
        min-height: 100vh;
    }

    .application--info__wrapper {
        background-color: white;
        max-width: 600px;
        height: 400px;
        position: relative;
        left: 20%;
        margin-top: 5%;
    }

    .application--info {
        padding: 3em;
    }

    .application__text {
        max-width: 90%;
    }


</style>


// WEBPACK FOOTER //
// src/components/applicationPageComponents/ApplicationHeader.vue